'use client';

import s from '@app/components/swiper/Swiper.module.css';
import { Left, Right, slugify } from 'mmds';
import ScrollBarSwiper from '../../components/scrollbar-swiper';
import { SwiperSlide } from 'swiper/react';
import React from 'react';
import BlogArticleCard from '@components/BlogArticleCard';

const RelatedStoryCardSlider = ({ articles, context, lang }) => {
    const instance = `related-story-card-swiper_${slugify(context)}`;
    return (
        <div className={s.swiperRoot} data-type="related story card slider">
            <div className={s.contextContainer}>
                <div className={s.context}>{context}</div>
                {articles.length > 3 && (
                    <div className={s.iconContainer}>
                        <div
                            className={`swiper-button swiper-icon-prev-${instance}`}
                        >
                            <Left />
                        </div>
                        <div
                            className={`swiper-button swiper-icon-next-${instance}`}
                        >
                            <Right />
                        </div>
                    </div>
                )}
            </div>
            <ScrollBarSwiper
                slidePerViewInMobile={1.17}
                slidePerViewInDesktop={3.3}
                spaceBetweenDesktop={12}
                spaceBetweenMobile={8}
                swiperIconPrevClassName={`swiper-icon-prev-${instance}`}
                swiperIconNextClassName={`swiper-icon-next-${instance}`}
                className={instance}
                key={instance}
                data-testid={instance}
            >
                {articles.map((article) => {
                    const { handle, content, publishedAt, image, title, tags } =
                        article;
                    const collectionTags = tags
                        .filter((tag) => tag.startsWith('collection:'))
                        .map((tag) => tag.replace('collection:', ''));
                    return (
                        <SwiperSlide
                            key={`related-story-card-slider-${handle}`}
                        >
                            <BlogArticleCard
                                swiper={true}
                                handle={handle}
                                body={content}
                                published_at={publishedAt}
                                imageUrl={image.transformedSrc}
                                title={title}
                                category={
                                    collectionTags[0]
                                        ? collectionTags[0]
                                        : handle
                                }
                                lang={lang}
                            />
                        </SwiperSlide>
                    );
                })}
            </ScrollBarSwiper>
        </div>
    );
};

export default RelatedStoryCardSlider;
